import {ApiClient} from '@hconnect/apiclient'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import type {MaterialStorage, DatamartSyncDetails} from '../types'

const datamartKeyToResource: Record<
  keyof DatamartSyncDetails,
  'tag-name' | 'tonne-conversion-factor'
> = {
  tagName: 'tag-name',
  tonneConversionFactor: 'tonne-conversion-factor'
}

type Variables = {
  plantCode: string
  storageId: number
  key: keyof DatamartSyncDetails
  dto: DatamartSyncDetails
}

export const useEditStorageDatamartConnection = ({
  onError,
  onSuccess
}: {
  onError?: (error: AxiosError, variables: Variables) => void
  onSuccess?: (data: MaterialStorage, variables: Variables) => void
} = {}) =>
  useMutation<MaterialStorage, AxiosError, Variables>({
    mutationFn: async ({plantCode, storageId, key, dto}) => {
      const response = await ApiClient.axiosInstance.patch<MaterialStorage>(
        `/plants/${plantCode}/material-storage/${storageId}/details/datamart/${datamartKeyToResource[key]}`,
        dto
      )
      return response.data
    },
    onError,
    onSuccess
  })
